import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { api } from "shared/api";
import { CreateOrderPaymentLinkPayload } from "shared/api/middleware-api-client";

// Function to create a standard order payment link
const createOrderPaymentLink = async (
  orderId: string,
  payload: CreateOrderPaymentLinkPayload,
) => {
  const res = await api().gersCreateOrderPaymentLink(orderId, payload);

  return res.data;
};

// Custom hook to handle the creation of a payment link for a standard product
export const useOrderCreatePaymentLink = () => {
  const {
    mutate: createOrderPaymentLinkToggle,
    isLoading: isCreateOrderPaymentLinkLoading,
  } = useMutation(
    ({
      orderId,
      payload,
    }: {
      orderId: string;
      payload: CreateOrderPaymentLinkPayload;
    }) => createOrderPaymentLink(orderId, payload),
    {
      // Redirect to the payment URL on successful creation of the payment link
      onSuccess: (data) => {
        window.location.href = data.paymentUrl;
      },
      // Show an error toast if there is an error during the creation of the payment link
      onError: () => {
        toast.error("Er is iets fout gegaan in het betaalproces.");
      },
    },
  );

  // Return the mutation function and loading state
  return {
    createOrderPaymentLinkToggle,
    isCreateOrderPaymentLinkLoading,
  };
};
